export default __webpack_public_path__ + "static/media/Aura-Egg__92.4c24bf4d.png";